import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-freevetcpd',
    templateUrl: './freevet.component.html',
    styleUrls: ['./freevet.component.scss']
})
export class FreevetComponent implements OnInit {

    public title:string='Free Online CPD for Vets and Veterinary Nurses';
    public blurbOne:string='This selection of our videos are available without a subscription and cover a range of subjects both theoretical and practical for vets and veterinary nurses. ';
    // Text for the link
    public blurbTwo:string='You just need to ';
    public blurbLinkText:string='register for free';
    public blurbLink:string='https://www.centralcpd.com/register';
    public blurbThree:string=' with us to gain access.';

    public image:string='https://www.centralcpd.com/assets/imgs/faq-header.jpg';

    public streams: any[];

    constructor() { }

    ngOnInit() {
        this.streamCPD();
    }

    streamCPD(){
        // Stream 0
        let stream0 = [];
        stream0['id'] = 3073;
        stream0['title'] = 'The Perils of Pandemic Puppies';
        stream0['suitable'] = 'Vets and Vet Nurses';
        stream0['cpd'] = '1 hour 43 minutes';
        stream0['image'] = '/assets/imgs/streams/stream0.jpg';

        // Stream 1
        let stream1 = [];
        stream1['id'] = 3138;
        stream1['title'] = 'An Introduction to Respiratory Medicine and Canine Nasal Disease';
        stream1['suitable'] = 'Vets';
        stream1['cpd'] = '1 hour 38 minutes';
        stream1['image'] = '/assets/imgs/streams/stream1.jpg';

        // Stream 2
        let stream2 = [];
        stream2['id'] = 3137;
        stream2['title'] = 'Feline Anaesthesia: Anaesthetic Equipment';
        stream2['suitable'] = 'Vet Nurses';
        stream2['cpd'] = '48 minutes';
        stream2['image'] = '/assets/imgs/streams/stream2.jpg';

        // Stream 3
        let stream3 = [];
        stream3['id'] = 3148;
        stream3['title'] = 'Practical Demonstration of an Exploratory Laparotomy';
        stream3['suitable'] = 'Vets';
        stream3['cpd'] = '19 minutes';
        stream3['image'] = '/assets/imgs/streams/stream3.jpg';

        // Stream 4
        let stream4 = [];
        stream4['id'] = 3139;
        stream4['title'] = 'Naso-Oesophageal Tube Placements in Cats';
        stream4['suitable'] = 'Vets and Vet Nurses';
        stream4['cpd'] = '7 minutes';
        stream4['image'] = '/assets/imgs/streams/stream4.jpg';

        // Stream 5
        let stream5 = [];
        stream5['id'] = 3142;
        stream5['title'] = 'Gastric Lavage Procedure';
        stream5['suitable'] = 'Vet Nurses';
        stream5['cpd'] = '2 minutes';
        stream5['image'] = '/assets/imgs/streams/stream5.jpg';

        // Stream 6
        let stream6 = [];
        stream6['id'] = 3205;
        stream6['title'] = 'Lunch and Learn Collection';
        stream6['suitable'] = 'Vets, Vet Nurses and Non-Clinical Staff';
        stream6['cpd'] = '28 minutes';
        stream6['image'] = '/assets/imgs/streams/stream6.jpg';

        this.streams = [
            stream0,
            stream1,
            stream2,
            stream3,
            stream4,
            stream5,
            stream6,
        ];
    };

    public popularSlideConfig = {
        "slidesToShow": 4,
        "slidesToScroll": 4,
        'arrows': true,
        autoplay: false,
        'responsive': [
            {'breakpoint': 1299, 'settings': { 'slidesToShow': 3, 'slidesToScroll': 3, 'arrows': true} },
            {'breakpoint': 900, 'settings': { 'slidesToShow': 2, 'slidesToScroll': 2, 'arrows': true} },
            {'breakpoint': 600, 'settings': { 'slidesToShow': 1, 'slidesToScroll': 1, 'arrows': true} },
        ]
    };
}